import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalStyles } from "./styles/globalStyles";
import { ApolloProvider, ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import "semantic-ui-less/semantic.less";
import ReactGA from "react-ga";
import { offsetLimitPagination } from "@apollo/client/utilities";

const trackingId = "UA-181863461-1";
ReactGA.initialize(trackingId);

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_SERVER_ENDPOINT}/graphql`,
  credentials: 'include', // Send cookies with requests
});

const authLink = setContext((_, { headers }) => {
  // Get the authentication token from local storage if it exists
  const token = localStorage.getItem("adminToken");
  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

// Error link to handle authentication errors globally
const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      // Skip login mutation errors - those should be handled by the login form
      if (operation.operationName === "Login") {
        continue;
      }
      
      // Check for authentication/authorization errors (but not "Invalid password")
      const isAuthError = 
        err.message.includes("Unauthorized") ||
        err.message.includes("jwt expired") ||
        err.message.includes("jwt malformed") ||
        err.message.includes("invalid signature") ||
        err.message.includes("Admin access required");
      
      if (isAuthError) {
        // Clear the invalid token
        localStorage.removeItem("adminToken");
        // Redirect to admin login if on an admin page
        if (window.location.pathname.startsWith("/admin")) {
          alert("Your session has expired. Please log in again.");
          window.location.href = "/admin";
        }
        break;
      }
    }
  }
  
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          obituaries: offsetLimitPagination(),
        },
      },
    },
  }),
});

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyles />
    <ApolloProvider client={client}>
      <Router>
        <App />
      </Router>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
